import React from 'react';

import { IVideoBlockFullwidthFields } from '../../../types/contentful';

import { VimeoVideo } from './VimeoVideo';
import { ScrollReveal } from '../ScrollReveal';
import cx from 'classnames';

interface Props extends IVideoBlockFullwidthFields {
  sysId?: string;
}

export function VideoBlockFullWidth(data: Props) {
  const { sysId, hidden } = data;

  return (
    <ScrollReveal>
      <div
        className={cx('block-container my-10 tablet:my-16', {
          hidden: !!hidden
        })}
        data-blockid="videoBlockFullwidth"
        data-testid="videoBlockFullwidth"
        data-elementid={sysId}
      >
        <div className="layout">
          <div className="column w-full">
            <VimeoVideo {...data} />
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
